import { api } from "../../../api/Middleware";
import { USERS_URL } from "../../../api/Urls";

// Listar todos os usuários
export const listUsers = async (params = {}) => {
  return await api.get(USERS_URL, { params });
};

// Buscar usuário específico
export const getUser = async (id) => {
  return await api.get(USERS_URL + `${id}/`);
};

// Criar novo usuário (método seguro)
export const createUserSecure = async (data) => {
  return await api.post(USERS_URL + "create_user_secure/", data);
};

// Atualizar usuário existente
export const updateUser = async (id, data) => {
  return await api.put(USERS_URL + `${id}/`, data);
};

// Atualizar parcialmente usuário
export const patchUser = async (id, data) => {
  return await api.patch(USERS_URL + `${id}/`, data);
};

// Deletar usuário (inativar)
export const deleteUser = async (id) => {
  return await api.delete(USERS_URL + `${id}/`);
};

export const validateCPF = async (data) => {
  try {
    let response = await api.post(USERS_URL + "validate_cpf/", data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Listar superusuários da conta
export const getSuperUsers = async () => {
  return await api.get(USERS_URL + "get_superusers/");
};

// Atualizar permissão específica do usuário
export const updateUserPermission = async (userId, permissionData) => {
  return await api.post(
    USERS_URL + `${userId}/update_user_permission/`,
    permissionData
  );
};

// Resetar permissões do usuário para padrão do nível
export const resetUserPermissions = async (userId) => {
  return await api.post(USERS_URL + `${userId}/reset_user_permissions/`, {});
};

// Criar primeiro admin (método especial)
export const createFirstAdmin = async (data) => {
  return await api.post(USERS_URL + "create_first_admin/", data);
};

// Upload de foto de usuário
export const uploadUserPhoto = async (userId, photoFile) => {
  const formData = new FormData();
  formData.append("photo", photoFile);

  return await api.patch(USERS_URL + `${userId}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getUserPermissions = async () => {
  return await api.get(`${USERS_URL}get_user_permissions/`);
};
